<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="400">
    <v-card class="py-2">
      <v-card-title class="text-h5">
        <span class="ml-0">Vista previa</span>
        <v-spacer />
        <v-btn icon @click="$emit('update:dialog', false)">
          <v-icon small> fas fa-times </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <ReplyMessagePreview :reply-message-selected="replyMessageSelected" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ReplyMessagePreview from "./ReplyMessagePreview";

export default {
  name: "WhatsAppReplyMessagePreviewModal",
  components: { ReplyMessagePreview },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    replyMessageSelected: {
      type: Object,
      required: true,
    },
  },
};
</script>
